import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const name = 'deleteGeneralFeedback';
const initialState = createInitialState();

function createInitialState() {
    return {
        done: false,
        error: false,
        spinner: false,
        deleteGeneralFeedback: null,
    };
}

export const deleteGeneralFeedback = createAsyncThunk('deleteGeneralFeedback', async (id, { rejectWithValue }) => {
    try {
        const response = await api.delete(`/super/api/feedback/general/delete/${id}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const deleteGeneralFeedbackSlice = createSlice({
    name: name,
    initialState,
    reducers: {
        resetDeleteGeneralFeedback: state => {
            state.done = false;
            state.error = false;
            state.spinner = false;
            state.deleteGeneralFeedback = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(deleteGeneralFeedback.pending, state => {
                state.spinner = true;
                state.error = false;
            })
            .addCase(deleteGeneralFeedback.fulfilled, (state, action) => {
                state.done = true;
                state.spinner = false;
                state.error = false;
                state.deleteGeneralFeedback = action.payload;
            })
            .addCase(deleteGeneralFeedback.rejected, (state, action) => {
                state.done = false;
                state.spinner = false;
                state.error = action.payload;
            });
    },
});

export const { resetDeleteGeneralFeedback } = deleteGeneralFeedbackSlice.actions;
export const deleteGeneralFeedbackReducer = deleteGeneralFeedbackSlice.reducer;
